import { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useRouter } from 'next/router';
import { staffQueryClient } from '@/services-satellites-admin-panel/staff-query-client';
import { Provider } from 'react-redux';
import { store } from '@/store/store';
import ReduxToastr from './ReduxToast';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const MainProvider: FC<any> = ({ children, Component }) => {
  const { pathname } = useRouter();
  const activeClient = pathname.startsWith('/satellites-admin-panel') ? staffQueryClient : queryClient;
  return (
    <Provider store={store}>
      <QueryClientProvider client={activeClient}>
        <ReduxToastr />
        {children}
      </QueryClientProvider>
    </Provider>
  );
};

export default MainProvider;
